/**
 * @generated SignedSource<<e61ef3c7c4029964a887b4ad327876db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AttributeType = "BOOLEAN" | "DATE" | "INTEGER" | "STRING" | "%future added value";
export type CreateAttributeDefinitionInput = {
  entityTypes: ReadonlyArray<string>;
  label: string;
  name: string;
  type: AttributeType;
};
export type CreateAttributeDefinitionDialogMutation$variables = {
  input: CreateAttributeDefinitionInput;
};
export type CreateAttributeDefinitionDialogMutation$data = {
  readonly createAttributeDefinition: {
    readonly attributeDefinitionEdge: {
      readonly node: {
        readonly entityTypes: ReadonlyArray<string>;
        readonly id: string;
        readonly label: string;
        readonly name: string;
        readonly type: AttributeType;
      } | null | undefined;
    };
  };
};
export type CreateAttributeDefinitionDialogMutation = {
  response: CreateAttributeDefinitionDialogMutation$data;
  variables: CreateAttributeDefinitionDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateAttributeDefinitionPayload",
    "kind": "LinkedField",
    "name": "createAttributeDefinition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AttributeDefinitionEdge",
        "kind": "LinkedField",
        "name": "attributeDefinitionEdge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AttributeDefinition",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "label",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entityTypes",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateAttributeDefinitionDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateAttributeDefinitionDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5c505f824d99a007e67ba764d611c4f8",
    "id": null,
    "metadata": {},
    "name": "CreateAttributeDefinitionDialogMutation",
    "operationKind": "mutation",
    "text": "mutation CreateAttributeDefinitionDialogMutation(\n  $input: CreateAttributeDefinitionInput!\n) {\n  createAttributeDefinition(input: $input) {\n    attributeDefinitionEdge {\n      node {\n        id\n        name\n        label\n        type\n        entityTypes\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0450b9c64cb30e6308d2573c6f7ecc6d";

export default node;
